import * as Tokens from '@hedtech/react-design-system/core/es/styles/tokens';
export { default as CtaColors } from '@hedtech/react-design-system/core/es/themes/common/ctaColors';
export default Tokens;
